import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  query getDevice($filter: deviceFilterInput) {
    getDevice(filter: $filter) {
      id
      referenceId
      macAddress
      type
      status
      brand {
        deviceType
        name
        id
      }
      organization {
        shortName
        name
        id
      }
      error {
        statusCode
        message
      }
    }
  }
`;

const initialState: TYPES.DeviceState = {
  result: null,
  error: null,
  loading: false
};

export const getDeviceRequest = createAsyncThunk<
  TYPES.Device,
  {filter?: TYPES.DeviceFilterInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'device/get_device',
  async (params: {filter?: TYPES.DeviceFilterInput;}, { extra: client }) => {
    try {
      const response = await client.query({
        query: GRAPHQL,
        variables: params
      });
      return response.data.getDevice;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const getDeviceSlice = createSlice({
  name: 'get_device',
  initialState: initialState,
  reducers: {
    getDeviceClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(getDeviceRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(getDeviceRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(getDeviceRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { getDeviceClear } = getDeviceSlice.actions;

export const getDevice = createSelector(
  (state: RootState) => state.device.getDevice.result,
  (state: RootState) => state.device.getDevice.error,
  (state: RootState) => state.device.getDevice.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default getDeviceSlice.reducer;